import { render, staticRenderFns } from "./FeaturedIn.vue?vue&type=template&id=42f55b7b"
import script from "./FeaturedIn.vue?vue&type=script&lang=js"
export * from "./FeaturedIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports